<template>
    <div class="searchFlaw">
        <div class="flaw-item" v-for="(item,index) in washProductFlawList" :key="index" @click="onFlaw(item)"
             :style=" flawString && flawString.includes(`${item.flawName}`) ?'background-color: #2d8cf0; color: #fff;' : ''">
            {{ item.flawName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    props: {
        flawString: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            washProductFlawList: []
        };
    },
    mounted() {
        this.getWashProductFlawList();
    },
    methods: {
        getWashProductFlawList() {
            get('/wash/utils/findAllWashProductFlaw').then((res) => {
                if (res.success) {
                    this.washProductFlawList = res.list;
                }
            });
        },

        onFlaw(flawItem) {
            this.$emit("onFlaw", flawItem)
        }
    }
};
</script>

<style scoped lang="scss">
.searchFlaw {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .flaw-item {
        display: inline-block;
        margin: 0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>